<template>
  <div class="certification-container">
    <div class="certification-title">
    <h1>À PROPOS DE SUPRACARE</h1>

  </div>
      <div class="breadcrumb">
      <a href="/">Accueil</a> > <a href="/certification">Qui sommes-Nous</a>
    </div>
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">

      <h2>Notre objectif</h2>
      <p>
        L’objectif de Supracare est de fournir les solutions de laboratoire les plus fiables et de haute qualité,
        grâce à des investissements continus dans la recherche, le développement et l'innovation.
      </p>

      <h2>Notre entreprise</h2>
      <p>
        Supracare est un fournisseur leader de produits de laboratoire et de santé, y compris des consommables, des produits chimiques,
        des réactifs et des compléments alimentaires. Nous nous engageons à offrir des solutions fiables pour les laboratoires, les cliniques,
        et les instituts de recherche à travers le Maroc, avec une attention particulière à la qualité et à la satisfaction client.
      </p>

      <h2>Notre certification</h2>
      <p>
        Notre certification ISO pour la fabrication et la distribution de produits de laboratoire garantit que les normes de qualité les plus élevées
        sont maintenues dans tous nos processus.
      </p>

      <h2>Notre engagement</h2>
      <p>
        Supracare s’engage à être à la pointe de l'industrie, en réinvestissant une partie significative de ses revenus dans l'innovation,
        pour offrir des produits toujours plus performants.
      </p>

      <h2>Notre succès</h2>
      <p>
        Depuis de nombreuses années, Supracare fournit des produits qui non seulement répondent mais dépassent les attentes du marché,
        grâce à une qualité supérieure, des prix compétitifs, et un service client exceptionnel.
      </p>
    </div>
  </div>
</template>


<script>
import { onMounted } from 'vue';

onMounted(() => console.log("Mounted"));

export default {
  name: 'CertificationI',
};
</script>

<style scoped>
.certification-container {
 padding: 0px 0px;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
  margin-bottom: 80px;
}

.certification-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); 
  z-index: -1;
}


.certification-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77); 
  padding: 100px 400px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
  max-width: 1000px; 
  z-index: 1;
}

.certification-title h1{
  color: black;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;

}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

/* Styles pour la description */
.supracare-description {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); 
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif; 
}

.supracare-description h2 {
  color: #4c4a4d; 
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Oswald', Helvetica, Arial, Lucida, sans-serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 60px;
  font-family: 'Open Sans', sans-serif;
}


/* Responsive pour les petits écrans */
@media only screen and (max-width: 1040px)  {
  .certification-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.8rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* Ajout de styles responsives pour mobile */
@media only screen and (max-width: 450px) {
  .certification-title {
    font-size: 12px;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* ================== MODE SOMBRE (auto) ================== */
@media (prefers-color-scheme: dark){

  /* Fond global + overlay plus discret (noir au lieu de blanc) */
  .certification-container{
    background:#0e1720;
    color:#e6edf1;
  }
  .certification-container::before{
    background-color: rgba(0,0,0,0.35); /* au lieu du voile blanc */
  }

  /* Bandeau image : même style mais lisible en sombre */
  .certification-title{
    color:#e6edf1;
    box-shadow: 0 10px 32px rgba(0,0,0,.5);
    position: relative;
  }
  /* léger voile pour renforcer le contraste du texte sur l’image */
  .certification-title::after{
    content:""; position:absolute; inset:0; border-radius: inherit; pointer-events:none;
    background: linear-gradient(180deg, rgba(0,0,0,.35), rgba(0,0,0,.2));
  }

  /* Fil d’Ariane (breadcrumb) */
  .breadcrumb{ color:#9fb3c8; }
  .breadcrumb a{
    color:#a5f3ee;
    text-decoration:none;
  }
  .breadcrumb a:hover{ color:#73d8cf; }

  /* Bloc description : conserve le même rendu mais adapté au sombre */
  .supracare-description{
    background:#0f1720;                 /* surface sombre subtile */
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 24px rgba(0,0,0,.5);
    border-radius: 2px;                 /* garde ton rayon */
  }
  .supracare-description h2{
    color:#e5ecff;
  }
  .supracare-description p{
    color:#cfe0e4;
  }
}

/* Option : micro-ajustement mobile en sombre (lisibilité) */
@media (prefers-color-scheme: dark) and (max-width:1040px){
  .certification-title{
    box-shadow: 0 8px 22px rgba(0,0,0,.55);
  }
}


</style>
